import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: _normalizeClass(['gfu-base-carousel-nav', $options.navClassName, $options.themeClassName]),
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('click')), ["prevent"]))
  }, [
    _createVNode(_component_base_icon, {
      name: $props.icon,
      "has-base-class": $props.hasIconBaseClass
    }, null, 8 /* PROPS */, ["name", "has-base-class"])
  ], 2 /* CLASS */))
}